import axios from 'axios'
import { arrayBufferToBlob, blobToDataURL } from 'blob-util'
export const downloadBase64 = ({ nome, base64 }) => {
  const a = window.document.createElement('a')
  a.download = nome

  a.href = `data:application;base64,${base64}`
  a.click()
}

export async function downloadConvertBase64 ({ url }) {
  const response = await axios({
    method: 'GET',
    url,
    responseType: 'arraybuffer'
  })

  let binary = ''
  const bytes = new Uint8Array(response.data)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }

  return btoa(binary)
}

export async function downloadConvertBase64Url ({ url }) {
  const response = await axios({
    method: 'GET',
    url,
    responseType: 'arraybuffer'
  })
  const myString = arrayBufferToBlob(response.data, response.headers['content-type'])
  return blobToDataURL(myString)
}

export const forceDownloadBase64 = async ({ nome, url }) => {
  const a = window.document.createElement('a')
  a.download = nome
  const base64 = await downloadConvertBase64({ url })

  a.href = `data:application;base64,${base64}`
  a.click()
}

export const forceDownloadURL = async ({ nome, url }) => {
  const a = window.document.createElement('a')
  a.download = nome
  a.href = url
  a.target = '_blank'
  a.click()
}
